<template>
    <v-layout fluid fill-height>

        <v-flex>
                <v-toolbar dense :elevation="0">
                    <v-toolbar-title class="text-primary-700">Edit Profile</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                          :elevation="0"
                           :disabled="!!errors.items.length"
                           @click="submit">Save
                    </v-btn>
                </v-toolbar>
                <v-divider class="my-2"></v-divider>
                <v-card-text>
                    <form>
                      <v-row>
                        <v-col cols="6">

                        
                          <v-text-field
                                  v-model="form.name"
                                  v-validate="'required|min:3'"
                                  :error-messages="errors.collect('form.name')"
                                  label="Name"
                                  data-vv-name="form.name"
                                  data-vv-as="Name"
                                  required
                                  outlined dense hide-details
                                  autocomplete="off"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                                  label="E-mail"
                                  name="profile_email"
                                  v-validate="'required|email'"
                                  v-model="form.email"
                                  :error-messages="errors.collect('form.email')"
                                  data-vv-name="form.email"
                                  data-vv-as="E-mail"
                                  required
                                  outlined dense hide-details
                                  autocomplete="off"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                                  label="Direct Dial"
                                  v-validate="''"
                                  v-model="form.direct_dial"
                                  :error-messages="errors.collect('form.direct_dial')"
                                  data-vv-name="form.direct_dial"
                                  data-vv-as="Direct Dial"
                                  autocomplete="off"
                                  outlined dense hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                                  label="Mobile"
                                  v-validate="''"
                                  v-model="form.mobile"
                                  :error-messages="errors.collect('form.mobile')"
                                  data-vv-name="form.mobile"
                                  data-vv-as="Mobile"
                                  autocomplete="off"
                                  outlined dense hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                                  label="Password"
                                  type="password"
                                  name="profile_password"
                                  v-validate="'min:5|max:50'"
                                  messages="leave the field blank if you do not want to change it"
                                  v-model="form.password"
                                  :error-messages="errors.collect('form.password')"
                                  data-vv-name="form.password"
                                  data-vv-as="Password"
                                  maxlength="50"
                                  autocomplete="off"
                                  outlined dense hide-details
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <currency-select v-model="form.currency" label="Base Currency"></currency-select>
                        </v-col>
                      </v-row>
<!--                      autocomplete="new-password"-->
                    </form>

                </v-card-text>

          <!-- <v-card v-if="!isAdmin() && !integration.graphConnected" class="mt-2" :elevation="0">
            <v-toolbar dense :elevation="0">
              <v-toolbar-title>Dropbox integration
                <v-btn v-if="integration.dropboxConnected" color="primary" @click="unlinkFromDropbox">Unlink</v-btn>
                <v-btn v-else color="primary" @click="redirectToDropbox">Login to Dropbox</v-btn>
              </v-toolbar-title>
            </v-toolbar>
          </v-card> -->

<!--          <v-btn color="primary" @click="redirectToDropbox">Login to Dropbox</v-btn>-->
            <!-- <v-card v-if="!isAdmin() && !integration.dropboxConnected" class="mt-2" :elevation="0">
                <v-toolbar dense :elevation="0">
                    <v-toolbar-title>Microsoft integration
                      <v-btn v-if="integration.graphConnected" color="primary" @click="unlinkFromMS">Unlink</v-btn>
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <div v-if="!integration.graphConnected">
                    <v-text-field
                      label="Primary domain or Tenant ID"
                      v-model="integration.graphDomain"
                      placeholder="your-site.co.uk"
                    ></v-text-field>
                    <v-btn color="primary" @click="redirectToMS">Login to Microsoft</v-btn>
                  </div>
                  <div v-else>
                    <v-autocomplete
                      v-model="integration.graphSharepointSite"
                      :loading="graphSharepointSites.loading"
                      :items="graphSharepointSites.items"
                      :search-input.sync="graphSharepointSites.search"
                      flat
                      hide-no-data
                      clearable
                      item-text="name"
                      item-value="id"
                      label="Sharepoint Site"
                      persistent-hint
                    ></v-autocomplete>
                    <v-btn v-if="!integration.graphSharepointSiteExists && integration.graphSharepointSite" color="primary" @click="updateSharepointSite">Save</v-btn>
                  </div>
                </v-card-text>

            </v-card> -->
        </v-flex>
    </v-layout>
</template>

<script>

import CurrencySelect from "@/components/common/currencySelect.vue";

export default {
  components: {CurrencySelect},
  data: () => ({
    form: {
      name: '',
      email: '',
      direct_dial: '',
      mobile: '',
      password: '',
      currency: null,
    },
    integration: {
      graphDomain: '',
      graphConnected: false,
      dropboxConnected: false,
      graphSharepointSite: null,
      graphSharepointSiteExists: false,
      graphTenantTitle: '',
    },

    graphSharepointSites: {
      loading: false,
      items: [],
      search: null,
    },
  }),
  watch: {
    'graphSharepointSites.search'(search) {
      this.getSharepointSites(search);
    },
  },

  mounted () {
    this.form.name = this.$auth.user().name
    this.form.email = this.$auth.user().email
    this.form.direct_dial = this.$auth.user().direct_dial
    this.form.mobile = this.$auth.user().mobile
    this.form.currency = this.$auth.user().currency

    this.integration.graphDomain = this.$auth.user().company.data.domain;
    this.integration.graphConnected = this.$auth.user().company.data.graph_connected;
    this.integration.dropboxConnected = this.$auth.user().company.data.dropbox_connected;
    this.integration.graphSharepointSite = this.$auth.user().company.data.graph_sharepoint_site;
    this.integration.graphSharepointSiteExists = !!this.$auth.user().company.data.graph_sharepoint_site;

    if(this.integration.graphConnected) {
      this.getSharepointSites();
    }
  },

  methods: {
    async getSharepointSites(search) {
      const response = await this.$http.get('/integrations/graph/sites', {
        params: {
          q: search,
        }
      });
      this.graphSharepointSites.items = response.data.data;
    },
    async redirectToMS() {
        if(this.integration.graphDomain === '') {
            this.$notify.error('Error', 'Please add your Primary domain or Tenant ID')
            return false;
        }
        let response = await this.$http.get('/integrations/graph/generate-connect-link', {
            params: {
                domain: this.integration.graphDomain,
            },
        });
        window.open(response.data, "_self");
    },
    async redirectToDropbox() {
        let response = await this.$http.get('/integrations/dropbox/generate-connect-link');
        window.open(response.data, "_self");
    },
    async updateSharepointSite() {
      await this.$http.put('/integrations/graph/update-site', {
        site_id: this.integration.graphSharepointSite
      })
    },
    async unlinkFromMS() {
      console.log('unlinking from MS')
      await this.$http.post('/integrations/graph/logout')
      this.integration.graphConnected = false;
      this.integration.graphSharepointSite = null;
      this.integration.graphSharepointSiteExists = false;
    },
    async unlinkFromDropbox() {
      console.log('unlinking from Dropbox')
      await this.$http.post('/integrations/dropbox/logout')
      this.integration.dropboxConnected = false;
    },
    async submit () {
      if (await this.$formValidator.validate(this.form)) {
        let formData = Object.assign({}, this.form)
        if (!formData.password.length) {
          delete formData.password
        }
        formData.currency = formData.currency.code
        await this.$http.put('/profile', formData)
        this.$auth.fetch()
        this.form.password = ''
      }
    }
  }
}
</script>

<style scoped>

</style>
